module.exports = __webpack_public_path__ + "static/img/s104.4ec433da.png";